import React, { Component } from 'react';

import AppContent from '../shared/AppContent';
import Alert from "../shared/Alert";
import {AuthContext} from "../../authContext";
import CategoryDisplayContainer from "../help/CategoryDisplayContainer";
import CategoryTitle from "../help/CategoryTitle";
import cityCADIcon from "../../assets/images/icons/citycad-grey.png";
import { citycadMajorVersion, helpArticlePath } from "../../configuration";
import { getCities, getLatestCityCADVersion, getSearchResults } from "../data/data";
import { frontPageContent } from "../../configuration";
import getResourceIconFromType from "../shared/utilities/getResourceIconFromType";
import HelpArticleIcon from "../shared/utilities/HelpArticleIcon";
import HelpResultCard from "../help/HelpResultCard";
import HelpResultCardContainer from "../help/HelpResultCardContainer";
import HelpResultIcon from "../help/HelpResultIcon";
import {isActiveSiteLayoutToolkitUser} from "../shared/utilities/isActiveSiteLayoutToolkitUser";
import Flex from '../shared/Flex';
import Loading from '../shared/Loading';
import PageHeading from "../shared/PageHeading";
import SearchResults from './SearchResults';
import TextInput from '../shared/form/TextInput';
import ResourceLink from '../shared/ResourceLink';
import WebLink from '../shared/WebLink';
import Badge from "../shared/Badge";
import FormHint from "../shared/form/FormHint";

class Homepage extends Component {
  static contextType = AuthContext;
  searchInterval = {};
  state = {
    searchTermConsistencyTimer: 0,
    previousSearchTerms: "",
    searchTerms: "",
    isLoading: false,
    cities: {},
    results: {},
    latestVersion: "",
    latestVersionURL: ""
  };
  changeTitle = title => {
    document.title = title;
  };
  componentWillUnmount() {
    clearInterval(this.searchInterval);
  }
  componentDidMount = async () => {
    let latestVersionData = await getLatestCityCADVersion();

    await this.setState({
      latestVersion: latestVersionData.data.latestVersion,
      latestVersionURL: latestVersionData.data.latestVersionURL
    });

    this.searchInterval = setInterval(async () => {
      this.setState({searchTermConsistencyTimer: this.state.searchTermConsistencyTimer + 1});

      if (this.state.searchTerms.length > 2 && this.state.searchTermConsistencyTimer > 5 && this.state.searchTerms !== this.state.previousSearchTerms) {
        this.search(this.state.searchTerms);
        await this.setState({previousSearchTerms: this.state.searchTerms, searchTermConsistencyTimer: 0});
      }

      if (this.state.searchTerms.length < 3 && this.state.searchTermConsistencyTimer > 5 && this.state.searchTerms !== this.state.previousSearchTerms) {
        await this.setState({previousSearchTerms: this.state.searchTerms, searchTermConsistencyTimer: 0, cities: {}, results: {}, isLoading: false})
      }
    }, 100);
  };
  handleSearchInputChange = async e => {
    await this.setState({searchTerms: e.target.value});
  };
  search = async searchTerms => {
    await this.setState({isLoading: true, results: {}});
    const results = await getSearchResults(searchTerms, citycadMajorVersion);
    const cities = await getCities(searchTerms);
    await this.setState({
      cities: cities.data,
      results: results.data,
      isLoading: false,
      searchTermConsistencyTimer: 0
    });
  };
  render() {
    if (this.props.isLoading === true) {
      return (
        <div/>
      );
    }
    return (
      <AppContent>
        {
          !isActiveSiteLayoutToolkitUser(this.context.userDetails.licences)
          &&
          (
            this.context.isCityCAD === true
              ?
              <React.Fragment>
                <PageHeading>
                  Welcome to CityCAD
                </PageHeading>
              </React.Fragment>
              :
              <PageHeading>
                Welcome to CityCAD Help
              </PageHeading>
          )
        }

        {/*{*/}
        {/*  <p>Hello {this.context.userDetails.firstName}, your site layout toolkit status is {isActiveSiteLayoutToolkitUser(this.context.userDetails.licences) ? 'yes' : 'no'}</p>*/}
        {/*}*/}

        {
          this.context.citycadVersion.majorVersion !== "3" && this.context.citycadVersion.majorVersion !== null
          &&
          <Alert>
            <h3>Upgrade to CityCAD 3.0 now</h3>
            <p>
              We are pleased to announce the release of CityCAD {this.state.latestVersion}.
              Please upgrade at the next convenient opportunity.
              This new version includes:
            </p>
            <ul>
              <li>64-bit platform</li>
              <li>Brand new user interface</li>
              <li>Cloud storage - easily share models with your colleagues</li>
            </ul>
            <p>
              If you have any questions please contact <a href={`mailto:support@holisticcity.co.uk`}>support@holisticcity.co.uk</a>
            </p>
            <p>
              <a target={`_blank`} href={this.state.latestVersionURL}>Download setup file now</a>
            </p>
          </Alert>
        }

        {
          !this.context.citycadVersion.isLatest && this.context.citycadVersion.majorVersion === "3"
          &&
          <Alert style={{marginBottom:"10px"}}>
            Please note a newer version {this.state.latestVersion} is now available. <br />
            <a target={`_blank`} href={this.state.latestVersionURL}>Download setup file now</a>
          </Alert>
        }

        {
          this.context.isCityCAD === true
          &&
          (
              this.context.messages.length > 0
              &&
              <CategoryTitle>{`My resources`}</CategoryTitle>
          )
        }
        {
          this.context.isCityCAD === true
          &&
          (
              this.context.messages.map(message => {
                if (message.type === 'message' || message.type === null) {
                  if (message.messageURL === null || message.messageURL === "") {
                    return (
                        <p key={message.id}>
                      <span>
                          {message.message}
                      </span>
                        </p>
                    )
                  }
                  else {
                    return (
                        <p key={message.id}>
                          <WebLink href={message.messageURL}>
                            {message.message}
                          </WebLink>
                        </p>
                    )
                  }
                }
                if (message.type === 'resource') {
                  return (
                      <ResourceLink key={message.id}>
                        {getResourceIconFromType()}
                        <span style={{marginLeft:"10px"}} onClick={() => this.changeTitle(message.title)}>
                      {message.message}
                    </span>
                      </ResourceLink>
                  )
                }
                return null;
              })
          )
        }

        <p>
          {
            this.context.isCityCAD !== true
            &&
            <strong>Search CityCAD Help and the City Design Library</strong>
          }

        </p>
        <Flex>
          <TextInput
              value={this.state.searchTerms}
              autoComplete={"off"}
              placeholder={`Search for anything...`}
              name="searchTerms"
              type="text"
              onChange={this.handleSearchInputChange}
          /><br />
        </Flex>
        <FormHint>Search for help articles, locations or place names.</FormHint>
        {this.state.isLoading && <Loading />}
        <SearchResults searchTerms={this.state.searchTerms} results={this.state.results} cities={this.state.cities}/>
        <hr />
        {
          this.context.isCityCAD === true
          &&
          <CategoryDisplayContainer gettingStarted={false}>
            {
              isActiveSiteLayoutToolkitUser(this.context.userDetails.licences)
              &&
              <HelpResultCard key={`sitelayouttoolkit`} onClick={e => {e.preventDefault(); this.context.navigate(`./analysis`)}}>
                <HelpResultIcon>
                  <HelpArticleIcon reference={`houses`} />
                </HelpResultIcon>
                <div>
                  Site Layout Toolkit <Badge bold>PREMIUM</Badge>
                </div>
              </HelpResultCard>
            }
            <HelpResultCardContainer>
              {frontPageContent.articles.map(article => {
                return (
                  <HelpResultCard key={article.id} onClick={e => {e.preventDefault(); this.context.navigate(`../../${helpArticlePath}${article.id}`)}}>
                  <HelpResultIcon>
                  <HelpArticleIcon reference={article.icon} />
                  </HelpResultIcon>
                  <div>
                  {article.title} {article.new === true && <Badge bold>NEW</Badge>}
                  </div>
                  </HelpResultCard>
                )
              })}
              <HelpResultCard key={`modellocation`} onClick={e => {e.preventDefault(); this.context.navigate(`./modellocation`)}}>
                <HelpResultIcon>
                  <HelpArticleIcon reference={`earth2`} />
                </HelpResultIcon>
                <div>
                  Set model location
                </div>
              </HelpResultCard>
            </HelpResultCardContainer>
          </CategoryDisplayContainer>
        }
        <hr />
        <p>
          {
            this.context.isCityCAD === true
            &&
            <small><img src={cityCADIcon} alt={`document`} style={{width:"12px", marginRight:"5px"}} /> Welcome to CityCAD.</small>
          }
          {
            (this.props.citycadVersion !== "" && this.context.isCityCAD === true)
            &&
            <small> You are using version {this.context.citycadVersion.versionString}</small>
          }
        </p>
      </AppContent>
    );
  }
}

export default Homepage;
